import { useState, useRef, useMemo } from 'react'
import { EffectCube } from 'swiper/modules'
import { Swiper, SwiperSlide, SwiperRef, SwiperClass } from 'swiper/react'
import { StoryType } from '~/widgets/Stories'
import { Posts } from '../Posts'

import 'swiper/css'
import 'swiper/css/effect-cube'

type CubeSwiperProps = {
  stories: StoryType[]
  selectedStoryId: UniqueId | null
  onClose: () => void
}

const DEFAULT_INDEX = 0

export function CubeSwiper({
  stories,
  selectedStoryId,
  onClose,
}: CubeSwiperProps) {
  const swiperRef = useRef<SwiperRef>(null)

  const initSlideIndex = useMemo(
    () => stories.findIndex((story) => story.id === selectedStoryId),
    [selectedStoryId, stories],
  )

  const [currentIndex, setCurrentIndex] = useState<number>(
    initSlideIndex || DEFAULT_INDEX,
  )

  const visibleStory = useMemo(
    () => stories[currentIndex],
    [currentIndex, stories],
  )

  const handleSlideChange = (swiper: SwiperClass) => {
    setCurrentIndex(swiper.activeIndex)
  }

  const handleNextSlide = () => {
    if (visibleStory.id === stories[stories.length - 1]?.id) {
      onClose()
      return
    }
    swiperRef?.current?.swiper.slideNext()
  }

  return (
    <Swiper
      initialSlide={initSlideIndex}
      ref={swiperRef}
      onSlideChange={handleSlideChange}
      effect='cube'
      cubeEffect={{
        shadow: false,
        slideShadows: false,
      }}
      modules={[EffectCube]}
      style={{
        width: '100%',
        height: '100%',
      }}
    >
      {stories.map((story, index) => {
        const shouldRender = Math.abs(currentIndex - index) <= 1
        return (
          <SwiperSlide key={story.id}>
            {shouldRender && (
              <Posts
                onClose={onClose}
                posts={story.posts}
                onAllPostsEnd={handleNextSlide}
              />
            )}
          </SwiperSlide>
        )
      })}
    </Swiper>
  )
}
